import dynamic from "next/dynamic";
import React from "react";
import { useAppContext } from "@components/Provider";
import { useTabletDetection } from "helpers/useTabletDetection";
import Header from "@components/Header/Header";
import Footer from "@components/Footer";

import styles from "./HomePageLayoutWithAds.module.css";
import ContentHeader from "@components/HeaderPage/ContentHeader";
import CatalogHeader from "@components/HeaderPage/CatalogHeader";
import Sites from "src/constants/Sites";

//Dynamic import based on https://github.com/zeit/next.js/blob/canary/examples/with-dynamic-import/pages/index.js
// {/ Load immediately, but in a separate bundle / }
const GoogleAdSense = dynamic(() => import("../Ads/GoogleAdSense"), {
  ssr: false,
});
const GoogleAdSenseDisplay = dynamic(() => import("../Ads/GoogleAdSenseDispalyAd"), { ssr: false });
const SheKnowsAd = dynamic(() => import("../Ads/SheKnowsAd"), { ssr: false });

const renderDisplayAd = (className, adnetwork, isMobile, displayResponsiveAd) => {
  if (!isMobile) {
    return (
      <React.Fragment>
        <div className={className} id="jatin">
          {adnetwork === "SheKnows" ? (
            displayResponsiveAd ? (
              <SheKnowsAd type={"medrec"} />
            ) : (
              <SheKnowsAd type={"banner"} />
            )
          ) : displayResponsiveAd ? (
            <GoogleAdSense />
          ) : (
            <GoogleAdSenseDisplay />
          )}
        </div>
      </React.Fragment>
    );
  }
};

const HomePageLayoutWithAds = (props) => {
  const { data, isMobile, subscriberCookie, siteId, isTablet: serverIsTablet } = useAppContext();

  // Enhanced client-side tablet detection using custom hook
  const { isTablet } = useTabletDetection(serverIsTablet, isMobile);
  let adnetwork = data.SiteSettings.ad_settings.adnetwork;
  return (
    <React.Fragment>
      <>
        <Header isNonClosableModalChecked={false} />
        {!isMobile &&
          !isTablet &&
          (siteId === Sites.OPENROADMEDIA ? (
            <CatalogHeader />
          ) : (
            <ContentHeader isMobile={isMobile} isTablet={isTablet} />
          ))}
      </>
      <div
        className={
          props.containerWithMargin
            ? [
                styles["layout_container"],
                "layout_container",
                styles["containerWithMargin"],
                "containerWithMargin",
              ].join(" ")
            : [styles["layout_container"], "layout_container"].join(" ")
        }
        style={{ "--subscriberCookie": subscriberCookie ? 1 : 0 }}
      >
        <div className={[styles["container"], "container", styles["noTopAd"], "noTopAd"].join(" ")}>
          {props.children}
        </div>
        {renderDisplayAd(
          [styles["bottomad"], "bottomad", styles["container"], "container"].join(" "),
          adnetwork,
          false,
          isMobile ? true : false //If it is mobile, want responvie ad, for desktop need re
        )}
      </div>
      <Footer />
    </React.Fragment>
  );
};

export default HomePageLayoutWithAds;
